"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var omit_1 = tslib_1.__importDefault(require("rc-util/lib/omit"));
var config_provider_1 = require("../config-provider");
var NormalCheck_1 = require("../Icons/NormalCheck");
var NormalClose_1 = require("../Icons/NormalClose");
var PromptCheckCircleFill_1 = require("../Icons/PromptCheckCircleFill");
var PromptCloseCircleFill_1 = require("../Icons/PromptCloseCircleFill");
var types_1 = require("../util/types");
var Circle_1 = tslib_1.__importDefault(require("./Circle"));
var Line_1 = tslib_1.__importDefault(require("./Line"));
var Steps_1 = tslib_1.__importDefault(require("./Steps"));
var utils_1 = require("./utils");
var ProgressTypes = (0, types_1.tuple)('line', 'circle', 'dashboard');
var ProgressStatuses = (0, types_1.tuple)('normal', 'exception', 'active', 'success');
var Progress = /** @class */ (function (_super) {
    tslib_1.__extends(Progress, _super);
    function Progress() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderProgress = function (_a) {
            var _b;
            var getPrefixCls = _a.getPrefixCls, direction = _a.direction;
            var props = _this.props;
            var customizePrefixCls = props.prefixCls, className = props.className, size = props.size, type = props.type, steps = props.steps, showInfo = props.showInfo, strokeColor = props.strokeColor, restProps = tslib_1.__rest(props, ["prefixCls", "className", "size", "type", "steps", "showInfo", "strokeColor"]);
            var prefixCls = getPrefixCls('progress', customizePrefixCls);
            var progressStatus = _this.getProgressStatus();
            var progressInfo = _this.renderProcessInfo(prefixCls, progressStatus);
            var progress;
            // Render progress shape
            if (type === 'line') {
                progress = steps ? (React.createElement(Steps_1.default, tslib_1.__assign({}, _this.props, { strokeColor: typeof strokeColor === 'string' ? strokeColor : undefined, prefixCls: prefixCls, steps: steps }), progressInfo)) : (React.createElement(Line_1.default, tslib_1.__assign({}, _this.props, { prefixCls: prefixCls, direction: direction }), progressInfo));
            }
            else if (type === 'circle' || type === 'dashboard') {
                progress = (React.createElement(Circle_1.default, tslib_1.__assign({}, _this.props, { prefixCls: prefixCls, progressStatus: progressStatus }), progressInfo));
            }
            var classString = (0, classnames_1.default)(prefixCls, (_b = {},
                _b["".concat(prefixCls, "-").concat((type === 'dashboard' && 'circle') || (steps && 'steps') || type)] = true,
                _b["".concat(prefixCls, "-status-").concat(progressStatus)] = true,
                _b["".concat(prefixCls, "-show-info")] = showInfo,
                _b["".concat(prefixCls, "-").concat(size)] = size,
                _b["".concat(prefixCls, "-rtl")] = direction === 'rtl',
                _b), className);
            return (React.createElement("div", tslib_1.__assign({}, (0, omit_1.default)(restProps, [
                'status',
                'format',
                'trailColor',
                'strokeWidth',
                'width',
                'gapDegree',
                'gapPosition',
                'strokeLinecap',
                'percent',
                'success',
                'successPercent',
            ]), { className: classString }), progress));
        };
        return _this;
    }
    Progress.prototype.getPercentNumber = function () {
        var _a = this.props.percent, percent = _a === void 0 ? 0 : _a;
        var successPercent = (0, utils_1.getSuccessPercent)(this.props);
        return parseInt(successPercent !== undefined ? successPercent.toString() : percent.toString(), 10);
    };
    Progress.prototype.getProgressStatus = function () {
        var status = this.props.status;
        if (ProgressStatuses.indexOf(status) < 0 && this.getPercentNumber() >= 100) {
            return 'success';
        }
        return status || 'normal';
    };
    Progress.prototype.renderProcessInfo = function (prefixCls, progressStatus) {
        var _a = this.props, showInfo = _a.showInfo, format = _a.format, type = _a.type, percent = _a.percent;
        var successPercent = (0, utils_1.getSuccessPercent)(this.props);
        if (!showInfo) {
            return null;
        }
        var text;
        var textFormatter = format || (function (percentNumber) { return "".concat(percentNumber, "%"); });
        var isLineType = type === 'line';
        if (format || (progressStatus !== 'exception' && progressStatus !== 'success')) {
            text = textFormatter((0, utils_1.validProgress)(percent), (0, utils_1.validProgress)(successPercent));
        }
        else if (progressStatus === 'exception') {
            text = isLineType ? React.createElement(PromptCloseCircleFill_1.PromptCloseCircleFill, null) : React.createElement(NormalClose_1.NormalClose, null);
        }
        else if (progressStatus === 'success') {
            text = isLineType ? React.createElement(PromptCheckCircleFill_1.PromptCheckCircleFill, null) : React.createElement(NormalCheck_1.NormalCheck, null);
        }
        return (React.createElement("span", { className: "".concat(prefixCls, "-text"), title: typeof text === 'string' ? text : undefined }, text));
    };
    Progress.prototype.render = function () {
        return React.createElement(config_provider_1.ConfigConsumer, null, this.renderProgress);
    };
    Progress.defaultProps = {
        type: 'line',
        percent: 0,
        showInfo: true,
        // null for different theme definition
        trailColor: null,
        size: 'default',
        gapDegree: undefined,
        strokeLinecap: 'round',
    };
    return Progress;
}(React.Component));
exports.default = Progress;
//# sourceMappingURL=progress.js.map